<template>
  <div>
    <b-row>
      <b-col>
        <SportTab offset-md="4"
                  :items="items"
                  :columns="columns"
                  :captionTab="captiontable"
                  :isCalled="false"
                  :selectedValue="selectedItem"
                  @editItem="showEditDialog"
                  @updateData="loadItems"
                  v-model="selectedItem"
                  :captionSpr="captionSport"
                  :stacked="stacked"
                  :urls="urls"
                  ref="SportTab"
        >
        </SportTab>
      </b-col>
    </b-row>

    <b-modal ref="editModal" v-model="modalEditOpened" title="Редактирование раздела ЕКП" size="lg" hide-footer
             id="editModal">
      <div class="d-block">

        <b-input-group prepend="Код" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите код" v-model="selectedItem.code"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.code">Указан пустой код</b-form-invalid-feedback>

        <b-input-group prepend="Наименование" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите наименование" v-model="selectedItem.name"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.fio">Указано пустое наименование</b-form-invalid-feedback>

        <b-input-group prepend="Федерация" class="mt-1" size="sm">
          <b-form-select v-model="selectedItem.federationId" :options="fedList">
            <template v-slot:first>
              <option :value="null">-- Выберите федерацию --</option>
            </template>
          </b-form-select>
        </b-input-group>

      </div>

      <div class="text-right">
        <b-button class="mt-1 mr-1" variant="outline-primary" @click="saveSport">Сохранить</b-button>
        <b-button class="mt-1" variant="outline-danger" @click="modalEditOpened=!modalEditOpened">Отменить</b-button>
      </div>

    </b-modal>

  </div>
</template>

<script>
import SportTab from '@/components/TabSpr.vue'
import http from '@/http-common'

export default {
  name: 'SportKind',
  components: {SportTab},
  data() {
    return {
      captiontable: 'Разделы ЕКП',
      items: [],
      editItem: {},
      urls: {
        save: '/sportkind/save',
        delete: '/sportkind',
      },
      captionSport: {
        name: 'Раздел ЕКП',
        nameR: 'раздела  ЕКП'
      },
      columns: [
        {key: 'code', label: 'Код'},
        {key: 'name', label: 'Наименование'},
        {key: 'federation', label: 'Федерация'},
        {key: 'edit_field', label: ''}
      ],
      selectedItem: {id: 0},
      modalEditOpened: false,
      validValue: {
        name: true,
        form: true,
      },
      stacked: {
        flg: false,
        size: 'md'
      },
      fedList: [],
    }
  },
  created() {
    this.loadItems();
  },
  methods: {
    loadFederations() {
      var vm = this;
      vm.fedList = [
        {value: 0, text: '-- Для всех --'}
      ]
      http.get('/federation/list')
      .then((response) => {
        //vm.fedList = response.data;
        response.data.forEach(function (x) {
          var obj = {}
          obj.value = x.id;
          obj.text = x.shortName;
          vm.fedList.push(obj)
        })
      })
      .catch((error) => console.log(error.message));
    },
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (!this.selectedItem.name || this.selectedItem.name === '') {
        this.validValue.name = false;
        this.validValue.form = false;
      }
    },
    loadItems() {
      var vm = this;
      http.get('/sportkind/list')
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.response.data));
    },
    showEditDialog() {
      this.loadFederations();
      this.modalEditOpened = !this.modalEditOpened;
    },
    saveSport() {
      this.checkForm();
      if (this.validValue.form) {
        this.modalEditOpened = false;
        this.$refs.SportTab.save(this.selectedItem);
      }
    }
  }
}
</script>
